import { render, staticRenderFns } from "./baseRecord.vue?vue&type=template&id=a6900c84&"
import script from "./baseRecord.vue?vue&type=script&lang=js&"
export * from "./baseRecord.vue?vue&type=script&lang=js&"
import style0 from "./baseRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports